import {Injectable} from '@angular/core';
import {Headers, Http, Response} from '@angular/http';

import 'rxjs/add/operator/toPromise';

import {URL_API} from '../constante';
import {HEADERS} from './../constante';
import {MAX_TAM_ARQ} from './../constante';
import {Trabalho} from './trabalho';
import {AcessoService} from "../acesso/acesso.service";
import {Autor} from "../autor/autor";

import {Utils} from '../shared/utils';
import {Usuario} from "../usuario/usuario";
import {AppComponent} from "../app.component";
import {AppService} from "../app.service";

@Injectable()
export class TrabalhoService extends AppService{

    private headers = new Headers();
    documentoUrl = URL_API + '/trabalho';
	unidades_executoras = [
	"Campus Macaé",
	"Decanato Centro de Ciências Jurídicas e economicas", 
	"Faculdade de Direito",
	"Escola de Educação Física e Desportos",
	"Faculdade de Farmácia",
	"Faculdade de Medicina",
	"Instituto de Biofísica",
	"Instituto de Ciências Biomédicas",
	"Instituto de Estudos de Saúde Coletiva",
	"Decanato Centro de Filosofia e Ciências Humanas",
	"Escola de Comunicação",
	"Instituto de Filosofia e Ciências Sociais",
	"Alojamento",
	"Colégio de Aplicação da UFRJ",
	"Casa da Ciência/Fórum de Ciência e Cultura (FCC)",
	"Colégio Brasileiro de Altos Estudos",
	"Complexo Hospitalar",
	"Coordenação dos programas de pós-graduação em engenharia",
	"Coordenação de pós-graduação e pesquisa em administração",
	"Centro de Ciências Matemáticas e da Natureza",
	"Decanato do Centro de Ciências da Saúde",
	"Decanato do Centro de Letras e Artes",
	"Decania do Centro de Tecnologia",
	"Difusão Cultural / Fórum de Ciência e Cultura",
	"Escola de Belas Artes",
	"Escola de Comunicação",
	"Editora / Fórum de Ciência e Cultura",
	"Escola de Enfermagem Ana Neri",
	"Escola de Educação Infantil",
	"Escola de música",
	"Escola de Química",
	"Escola de Serviço Social",
	"Escola politécnica",
	"Escritório Técnico da Universidade",
	"Faculdade de economia e administração",
	"Faculdade de Educação",
	"Faculdade de Letras",
	"Faculdade de Odontologia",
	"Faculdade de Arquitetura e Urbanismo",
	"Fórum de Ciência e Cultura",
	"Gabinete do Reitor",
	"Hospital Escola São Francisco de Assis",
	"Hospital Universitário",
	"Instituto de Bioquímica Médica",
	"Instituto de Doenças do Tórax",
	"Instituto de Macromoléculas",
	"Instituto de Biologia",
	"Instituto de Economia Industrial",
	"Instituto de Física",
	"Instituto de Goeciências",
	"Instituto de Ginecologia",
	"Instituto de História",
	"Instituto da Matemática",
	"Instituto da Microbiologia",
	"Instituto de Neurologia Deolindo Couto",
	"Instituto de Nutrição Josué de Castro",
	"Instituto de psicologia",
	"Instituto de psiquiatria",
	"Instituto de Química",
	"Instituto do Coração Edson Saad",
	"Instituto Puericultura Pediátrica e maternidade Gesteira",
	"Núcleo de Planejamento Urbano e Regional",
	"Maternidade Escola",
	"Museu Nacional",
	"Núcleo de Computação Eletrônica",
	"Núcleo de Estudos Internacionais",
	"Núcleo de Estudos em Políticas Públicas em Direitos Humanos",
	"Núcleo de Pesquisa de Produtos Naturais",
	"Núcleo de Pesquisas Ecológicas de Macaé",
	"Núcleo de Tecnologia Educacional para Saúde",
	"Observatório do Valongo",
	"Pólo Xerém",
	"PR1 - Pró-Reitoria de Graduação",
	"PR2 - Pró-Reitoria de Pós-Graduação",
	"PR3 - Pró-Reitoria de Planejamento e Desenvolvimento",
	"PR4 - Pró-reitoria de Pessoal",
	"PR5 - Pró-Reitoria de Extensão",
	"PR6 - Pró-Reitoria de Gestão e Governança",
	"Prefeitura Universitária",
	"Restaurante Universitário",
	"Sistema de bibliotecas e Informação",
	"Centro Nacional de Bioimagens",
	"Núcleo Interdisciplinar para o Desenvolvimento",
	"Comissão de Vestibular"
	];

    // constructor(private http: Http,
    //     private acessoService: AcessoService,
    //     private utils: Utils, {
    //     // this.headers.append('Content-Type', 'multipart/form-data, boundary="1324"');
    //     this.headers.append('Accept', 'application/json; text/plain, */*');
    // }

    getTrabalhos(recursos: boolean): Promise<Trabalho[]> {
        return this.http.get(this.documentoUrl + (recursos? '/recursos' : ''))
            .toPromise()
            .then(response => response.json() as Trabalho[])
            .catch((error) => this.utils.handleError(error));
    }

    getTrabalhosByParecerista(recursos: boolean): Promise<Trabalho[]> {
        let usuario_id = this.acessoService.getUsuario().id;

        return this.http.get(this.documentoUrl + (recursos? '/recursista/' : '/parecerista/') + usuario_id)
            .toPromise()
            .then(response => response.json() as Trabalho[])
            .catch((error) => this.utils.handleError(error));
    }

    getTrabalhosPorUsuario(): Promise<Trabalho[]> {
        let usuario_id = this.acessoService.getUsuario().id;

        return this.http.get(this.documentoUrl + '/usuario/' + usuario_id)
            .toPromise()
            .then(response => response.json() as Trabalho[])
            .catch((error) => this.utils.handleError(error));
    }

    del(dados: any): Promise<Response> {
        let url: string = this.documentoUrl + '/delete';
        dados['user']= sessionStorage.getItem('api_token');
        return this.http
            .post(url, dados, {headers: HEADERS})
            .toPromise()
            .then(response => this.utils.handle(response))
            .catch((error) => this.utils.handleError(error));
    }

    getTrabalho(id): Promise<Trabalho> {
        return this.http.get(this.documentoUrl+"/"+id)
            .toPromise()
            .then(response => response.json() as Trabalho)
            .catch((error) => this.utils.handleError(error));
    }
	
	getEtapas(id): Promise<any> {
		return this.http.get(this.documentoUrl + '/etapas/' + id)
			.toPromise()
			.then(response => response.json())
			.catch((error) => this.utils.handleError(error));
	}

	validarDatas(trabalho: Trabalho): string {
		let datasIni: any[] = trabalho.datas_ini;
		let datasFim: any[] = trabalho.datas_fim;
		let i: number = datasIni.length; 
		
		if (!i)
			return "É preciso haver ao menos um par de datas.";
		
		if (!datasIni[0] || !datasFim[0])
			return "As datas precisam ser definidas.";
		
		if (datasIni[0].jsdate <= new Date())
			return "A data inicial da primeira etapa deve ser maior do que a data atual.";
		
		while (--i >= 0) {
			if (!datasIni[i] || !datasFim[i])
				return "As datas precisam ser definidas.";
			if (datasIni[i].jsdate > datasFim[i].jsdate)
				return "A data final de uma etapa não pode ser menor do que a inicial."; 
			if (i > 0 && datasFim[i - 1].jsdate >= datasIni[i].jsdate)
				return "A data final de uma etapa deve ser menor do que a inicial da próxima etapa.";
		}
		
		if (trabalho.inicio_evento) {
			if (!trabalho.fim_evento)
				return "O fim de evento é obrigatório se tiver início de evento.";
			if (new Date(trabalho.fim_evento) <= new Date(trabalho.inicio_evento))
				return "O fim de evento deve ser posterior ao início de evento.";
		}
		else 
			trabalho.inicio_evento = trabalho.fim_evento = null;
		
		return null;
	}
	
    getAutores(id): Promise<Autor[]> {
        let url = URL_API + "/autor/trabalho/"+ id;
        return this.http.get(url)
            .toPromise()
            .then(response => response.json() as Autor[])
            .catch((error) => this.utils.handleError(error));
    }

    salvar(dados_trabalho: any, update: boolean): Promise<Trabalho> {

		if (dados_trabalho.parecer && dados_trabalho.parecer instanceof File) {
			if (dados_trabalho.parecer.size > MAX_TAM_ARQ) {
				this.utils.exibirMensagem('O tamanho do arquivo tem que ser menor do que 10 Mb.', 'danger');
				return null;
			}

			if (!dados_trabalho.parecer.name.endsWith('.pdf'))
			{
				this.utils.exibirMensagem('O arquivo precisa ser um PDF!', 'warning');
				return null;
			}
			
			dados_trabalho.tamanho = dados_trabalho.parecer.size;
		} 
		dados_trabalho['user']= sessionStorage.getItem('api_token');
        return this.http.post(this.documentoUrl + (update? '/update' : ''), this.utils.buildFormData(dados_trabalho))
            .toPromise()
            .then(response => response.json() as Trabalho[])
            .catch((error) => this.utils.handleError(error));
    }

    //promise type
    checkautor(dados): Promise<number> {
        // console.log(dados);
        let url= URL_API+"/"+"autor";
        return this.http.post(url, dados, {headers: HEADERS})
            .toPromise()
            .then(response => response.json())
            .catch((error) => this.utils.handleError(error));
    }
	
	salvarOrcamento(trabalhoId: number, orcamento: number): Promise<Response> {
		return this.http.get(URL_API + '/trabalho/orcamento/' + trabalhoId + '/' + orcamento, {headers: HEADERS})
            .toPromise().then(response => this.utils.handle(response)).catch(error => this.utils.handleError(error));
    }
}



// WEBPACK FOOTER //
// ./src/app/trabalho/trabalho.service.ts